/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { apiFetch } from '../../shared/apiClient';
import Bet, { BetId } from './types/Bet';
import BetResult from './types/BetResult';
import BetsPage from './types/BetsPage';
import GameResult from './types/GameResult';
import NewEmptyBet from './types/NewEmptyBet';
import NewOpenedBet from './types/NewOpenedBet';
import UpdatedBet from './types/UpdatedBet';

export async function addOpenedBet(newOpenedBet: NewOpenedBet): Promise<Bet> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/add`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/add`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		body: JSON.stringify(newOpenedBet),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function addEmptyBet(newEmptyBet: NewEmptyBet): Promise<Bet> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/add/empty`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/add/empty`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		body: JSON.stringify(newEmptyBet),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function setBetResult(betId: string, betResult: BetResult): Promise<Bet> {
	console.log(betResult);

	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/${betId}/set-bet-result`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/${betId}/set-bet-result`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'PUT',
		body: JSON.stringify(betResult),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function sendGameResults(
	seasonId: string,
	gameResults: GameResult[]
): Promise<{ bets: Bet[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/set-auto-bet-results`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/set-auto-bet-results`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		body: JSON.stringify({ seasonId, gameResults }),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getOpenedBets(seasonId: string): Promise<{ bets: Bet[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/opened/seasons/${seasonId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/opened/seasons/${seasonId}`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getUserSlotBets(
	seasonId: string,
	leagueId: string,
	matchDay: string
): Promise<{ bets: Bet[] }> {
	const queryParams = new URLSearchParams({ leagueId, matchDay });
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/slot/seasons/${seasonId}?${queryParams.toString()}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/slot/seasons/${seasonId}?${queryParams.toString()}`;
	}
	const result = await apiFetch(url);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getSlotMatchBetCounts(
	seasonId: string,
	leagueId: string,
	matchDay: string
): Promise<{ counts: Record<string, number> }> {
	const queryParams = new URLSearchParams({ leagueId, matchDay });
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/match-counts/seasons/${seasonId}?${queryParams.toString()}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/match-counts/seasons/${seasonId}?${queryParams.toString()}`;
	}
	const result = await apiFetch(url);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getMatchBets(
	seasonId: string,
	matchScheduleId: string
): Promise<{ bets: Bet[] }> {
	const queryParams = new URLSearchParams({ matchScheduleId });
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/match/seasons/${seasonId}?${queryParams.toString()}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/match/seasons/${seasonId}?${queryParams.toString()}`;
	}
	const result = await apiFetch(url);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

// export async function getCompletedBets(
// 	seasonId: string,
// 	playerId?: string,
// 	leagueId?: string,
// 	size?: string,
// 	pageNumber?: number
// ): Promise<BetsPage> {
// 	const queryParams = new URLSearchParams({
// 		...(playerId && { playerId }),
// 		...(leagueId && { leagueId }),
// 		...(size && { size }),
// 		...(pageNumber && { page: pageNumber.toString() }),
// 	});

// 	const queryString = queryParams.toString();
// 	const baseUrl =
// 		import.meta.env.VITE_PRODUCT_SERVER === 'localhost' ? '' : import.meta.env.VITE_PRODUCT_SERVER;

// 	const url = `${baseUrl}/api/bets/completed/seasons/${seasonId}${
// 		queryString ? `?${queryString}` : ''
// 	}`;

// 	const result = await apiFetch(url);

// 	if (result.status >= 400) {
// 		const { message }: { message: string } = await result.json();
// 		throw new Error(message);
// 	}

// 	return result.json();
// }

export async function getCompletedBets(
	seasonId: string,
	playerId?: string,
	leagueId?: string,
	size?: string,
	pageNumber?: number
): Promise<BetsPage> {
	const queryParams = new URLSearchParams();
	if (playerId) queryParams.append('playerId', playerId);
	if (leagueId) queryParams.append('leagueId', leagueId);
	if (size) queryParams.append('size', size);
	if (pageNumber) queryParams.append('page', pageNumber.toString());
	const queryString = queryParams.toString();
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/completed/seasons/${seasonId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/completed/seasons/${seasonId}`;
	}
	if (queryString) {
		url += `?${queryString}`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getAllBets(
	seasonId: string,
	size?: string,
	pageNumber?: number
): Promise<BetsPage> {
	const queryParams = new URLSearchParams();
	if (size) queryParams.append('size', size);
	if (pageNumber) queryParams.append('page', pageNumber.toString());
	const queryString = queryParams.toString();
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/all/seasons/${seasonId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/all/seasons/${seasonId}`;
	}
	if (queryString) {
		url += `?${queryString}`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function updateBet(editedBetId: string, editedBet: UpdatedBet): Promise<Bet> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/${editedBetId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/${editedBetId}`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'PUT',
		body: JSON.stringify(editedBet),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function deleteBet(
	betId: BetId,
	seasonId: string,
	leagueId: string,
	calendarNodeId: string
): Promise<Bet> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/${betId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/${betId}`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'DELETE',
		body: JSON.stringify({ seasonId, leagueId, calendarNodeId }),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getBetTitleCodeLabelMap(): Promise<{
	betTitleCodeLabelMap: Record<number, string>;
}> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/bets/betTitleCodeLabelMap`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/bets/betTitleCodeLabelMap`;
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}
